module.exports = __webpack_public_path__ + "static/media/changtu.6e964b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/image/changtu.png
// module id = 784
// module chunks = 0